export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8387.4ada87a2.jpg";